/* AUTO-GENERATED from /schemas/*.schema.json — DO NOT EDIT.
   Regenerate with: node tooling/contracts/generate.mjs */

export const DECISION_INPUT_OPTIONS = {
  "customerTypes": [
    "private",
    "business"
  ],
  "booleanFields": [
    "event.is_multiday",
    "event.is_outdoor",
    "catering.sweet_requested",
    "catering.service_staff_required",
    "catering.tableware_required",
    "catering.buffet_tables_required",
    "logistics.ground_level_delivery",
    "logistics.elevator_available",
    "logistics.elevator_suitable",
    "logistics.kitchen_available",
    "logistics.grill_available_on_site",
    "logistics.grill_requested_from_neo",
    "logistics.grillmaster_requested",
    "logistics.cook_requested",
    "logistics.weather_protection_available",
    "logistics.pavilion_requested",
    "event.guest_count_deferred"
  ],
  "listFields": [
    "catering.dietary_requirements",
    "logistics.kitchen_equipment",
    "logistics.trade_fair_equipment"
  ],
  "numericFields": [
    "catering.course_count",
    "logistics.stand_floors",
    "catering.dietary_guest_counts",
    "catering.budget_total_eur"
  ],
  "drinkNeeds": [
    "required",
    "not_required",
    "unspecified"
  ],
  "drinkSuppliers": [
    "caterer",
    "venue",
    "customer",
    "other",
    "not_caterer",
    "unspecified"
  ],
  "venueKinds": [
    "venue",
    "trade_fair",
    "generic",
    "unresolved"
  ]
} as const;

/**
 * Customer-stated drink need, supplier and concrete drink specifications. No package, quantity or eligibility decision.
 */
export interface DrinksValue {
  version: 1;
  need: "required" | "not_required" | "unspecified";
  supplier: "caterer" | "venue" | "customer" | "other" | "not_caterer" | "unspecified";
  /**
   * @maxItems 24
   */
  details: string[];
}

/**
 * Evidence-backed location meaning. A named venue is not a postal address and grants no lookup authority.
 */
export interface VenueValue {
  version: 1;
  kind: "venue" | "trade_fair" | "generic" | "unresolved";
  name: string;
}

/**
 * Explicit postal components of the event/delivery address. Null components stay unknown; never populate from venue classification or infer a missing component.
 */
export interface PostalAddressValue {
  version: 1;
  street: string | null;
  house_number: string | null;
  postal_code: string | null;
  locality: string | null;
}
